/* eslint-disable import/prefer-default-export */
enum NatureOfBusinessOptions {
  YES = 'yes',
  NO = 'no',
}

export { NatureOfBusinessOptions };
